import { ILoggingService, LiveStreamDisciplineType, LiveStreamErrorType } from 'eTip--common';
import { useRef, useState } from 'react';
import React from 'react';
import { LiveStreamLoader } from './liveStreamLoader';

interface IBRPlayer {
    load: (source: string) => void;
    playVideo: () => void;
    stopVideo: () => void;
    remove: () => void;
    //resetVideoSize: () => void;
    /*loaded(): ISignal;
    //getPlayState(): PlayState;
    error(): ISimpleEvent<AVVPLError>,
    ended(): ISimpleEvent<number>,
    //playing(): ISimpleEvent<number>,
    streamStarted(): ISignal,
    userIdle(): ISimpleEvent<boolean>, //isUserIdle(): boolean
    getDimensions(): { height: string, width: string },
    //getPlayState(): PlayState*/
    off: (eventname: string, callback?: (payload?: any) => void) => void;
    on: (eventname: string, callback?: (payload?: any) => void) => void;
    canHandleStream(url: string, mimeType?: string): boolean;
    handlerLoaded: ISimpleEvent<number>;
}


/*interface AVVPLError {
}

interface ISignal {
    subscribe: (callback: () => void) => void;
    unsubscribe: (callback: () => void) => void;
}
*/
interface ISimpleEvent<T> {
    subscribe: (callback: (param: T) => void) => void;
    unsubscribe: (callback: (param: T) => void) => void;
}

interface IBRVideoPlayerProps {
    eventId: number;
    eventDiscipline: LiveStreamDisciplineType,
    eventCategoryPath: string;
    canResizeAutomatically: boolean;
    linkHls: string;
    linkDash: string;
    elementId: string;
    isTouchUI: boolean;
    loggingService: ILoggingService;
    canLimitWidth: boolean;
    popupWindowData: { streamId: string, userId: number, token: string, eventId: number, eventName: string, eventDiscipline: LiveStreamDisciplineType, eventCategoryPath: string } | null;
    refreshSources: () => void;
    errorLoadingContent: (errorType: LiveStreamErrorType) => void;
    shownForMonitoring: () => void;
    closeVideo?: () => void;
}

const isMobilefromAgent = () => {
    return (navigator.userAgent.match(/Android/i)
        || navigator.userAgent.match(/webOS/i)
        || navigator.userAgent.match(/iPhone/i)
        || navigator.userAgent.match(/iPad/i)
        || navigator.userAgent.match(/iPod/i)
        || navigator.userAgent.match(/BlackBerry/i)
        || navigator.userAgent.match(/IEMobile/i)
        || navigator.userAgent.match(/Opera Mini/i)
        || navigator.userAgent.match(/Windows Phone/i))
        && Math.max(screen.width, screen.height) < 1024; //to cut tablets (specific for BR licence), checked for small samsung android tablat and ipad min (they has 1024px)
}

/**
 * Returns width for live stream container.
 *
 * @param isMobile? empty isMobile is expected for error or load content only!
 * @param isRestrictedToMaxWidth50Pct? empty isMobile is expected for error or load content only!
 */
export const getMaxWidthOfLiveStreamForCss = (isMobile?: boolean, isRestrictedToMaxWidth50Pct?: boolean): string => {
    if (isMobile === undefined) {
        isMobile = isMobilefromAgent();
        isRestrictedToMaxWidth50Pct = false; // expecting for error or loader only.
    }
    if (isMobile) {
        if (isRestrictedToMaxWidth50Pct) {
            return "50%";
        }
        return "100%";
    } else {
        return getMaxWidthOfLiveStreamOnDesktopValue() + "px";
    }
}

const getMaxWidthOfLiveStreamOnDesktopValue = () => {
    return Math.floor(screen.width / 3);
}

/*const closeMonitor = (() => {

    //expected to close popup when main window is closing.But the same is simple refresh and it may be annoying.

    let lastWindow: Window = null;

    const setLastOpenWindowInstance = (window: Window) => {
        lastWindow = window;
    }

    window.addEventListener("beforeunload", () => {
        if (lastWindow) {
            lastWindow.close();
        }
        return true;
    })

    return {
        setLastOpenWindowInstance
    }
})();*/

//https://docs.betradar.com/display/BD/AudioVisual+Video+Player
//https://avplayer-cdn.sportradar.com/docs/classes/videoplayer.html

export const BetradarVideoPlayer: React.FC<IBRVideoPlayerProps> = (props: IBRVideoPlayerProps) => {
    const [stateEventId, stateSetEventId] = useState<number>(null);
    const [statePlayerWasReady, setStatePlayerWasReady] = useState<boolean>(false);
    const [isTopControlVisible, setIsTopControlVisible] = useState<boolean>(false);
    const [stateClientWidth, stateSetClientWidth] = useState<number>(-1);

    const player = useRef<IBRPlayer>(null);
    let wrapperRef = React.useRef<HTMLDivElement>();
    let fileHasBeenPlayed = false;

    /*
    On Desktop max 1/3 of screen size.
    On mobile phones (not on tablets) full screen video is permitted (except for ATP, it must be restricted to 50%). Challenger, ITF and eSoccer full screen video is permitted on all device types.
    */
    const isMobileEvaluated = isMobilefromAgent();
    const isFullScreenAllowedByEventCat = isMobileEvaluated || (props.eventDiscipline === LiveStreamDisciplineType.Tennis && (props.eventCategoryPath.startsWith("ITF") || props.eventCategoryPath.startsWith("Challenger"))); // well not perfect, on RU translated only. By ID?
    const isRestrictedToMaxWidth50Pct = isMobileEvaluated && (props.eventDiscipline === LiveStreamDisciplineType.Tennis && props.eventCategoryPath.startsWith("ATP"));

    React.useEffect(() => {
        if (stateEventId !== props.eventId) {
            stateSetEventId(props.eventId);
            init();
        }
        return destroyPlayer;
    }, [props.eventId]); //!! release

    React.useEffect(() => { //final destroy (from matchtracker, probably not necessary)
        return destroyPlayer;
    }, []);

    if (props.canResizeAutomatically) {
        React.useLayoutEffect(() => {
            if (!wrapperRef.current) {
                return;
            }
            if (stateClientWidth !== wrapperRef.current.clientWidth) {
                //console.log("useLayoutEffect " + wrapperRef.current.clientWidth);
                if (stateClientWidth > 0) {
                    window.setTimeout(() => {
                        let resizeEvent = new Event('resize'); //player can react to window resize only
                        window.dispatchEvent(resizeEvent);
                        window.dispatchEvent(resizeEvent); //need twice since in Desktop Favorites more windows resize on the first run (masonry)
                        window.dispatchEvent(resizeEvent);
                    }, 300);

                    //window.dispatchEvent(resizeEvent);
                }
                stateSetClientWidth(wrapperRef.current.clientWidth);
            }

        });
    }

    const init = (): void => {

        props.shownForMonitoring();

        setStatePlayerWasReady(false);
        var playerFactory = window['avvpl'];
        if (playerFactory) {
            run(playerFactory);
            return;
        }

        let elScript = document.createElement("script");
        elScript.async = true;
        elScript.src = "https://avplayer-cdn.sportradar.com/dist/latest/avvpl-player.js";
        document.getElementsByTagName("head")[0].append(elScript);

        let elStyle = document.createElement("link");
        elStyle.type = "text/css";
        elStyle.rel = "stylesheet";
        elStyle.href = "https://avplayer-cdn.sportradar.com/dist/latest/styles.css";
        document.getElementsByTagName("head")[0].append(elStyle);

        waitingForLoad(1);

    }

    const waitingForLoad = (interation: number): void => {
        var playerFactory = window['avvpl'];
        if (playerFactory) {
            run(playerFactory);
            return;
        }

        if (interation > 13) {
            props.errorLoadingContent(LiveStreamErrorType.StreamFirstLoad);
        }
        window.setTimeout(() => {
            waitingForLoad(interation++);
        }, 1000);
    }

    const run = (avvpl: any): void => {
        fileHasBeenPlayed = false;
        let config = {
            id: props.elementId,
            allowFullScreen: isFullScreenAllowedByEventCat,
            enableUI: true,
            trackLiveEdge: true,
            //loglevel: 3,
            //language: "en", /* en/de */
            handlers: ["html5", "hls", "dash"]
        };

        player.current = new avvpl.setupPlayer(config);

        player.current.on("streamStarted", () => {
            //console.log("streamStarted");
            setStatePlayerWasReady(true);
            fileHasBeenPlayed = true;
        });

        player.current.on("loaded", () => {
            //player is loaded but not content
            setStatePlayerWasReady(true);
        })

        player.current.on("error", (error) => {
            //console.log("error", error);

            if (error.message.type.indexOf("Video Format Error") >= 0) {
                if (fileHasBeenPlayed) {
                    destroyPlayer();
                    props.refreshSources();
                    return;
                }
            }

            if (fileHasBeenPlayed) {
                props.errorLoadingContent(LiveStreamErrorType.StreamErrorLater);
                return;
            }

            props.errorLoadingContent(LiveStreamErrorType.General);

        });

        /*player.on("ended", () => {
            console.log("ended");
        });

        player.on("userIdle", () => {
            console.log("userIdle");
        });*/

        /*if (!props.isTouchUI) {
            player.playVideo();
        }*/

        setStatePlayerWasReady(true);
    }

    const destroyPlayer = (): void => {
        if (player.current && window['avvpl']) {
            try {
                player.current.stopVideo();
                player.current.remove();
                player.current = null;
            } catch (e) {
                props.loggingService.error(e);
            }
        }
    }

    return <>
        {!statePlayerWasReady && <LiveStreamLoader />}
        <div
            className={`${isTopControlVisible ? ' with-controls ' : ''}`}
            onMouseEnter={() => { setIsTopControlVisible(true) }}
            onMouseLeave={() => { setIsTopControlVisible(false) }}
            id={props.elementId}
            ref={wrapperRef}
            style={{
                maxWidth: getMaxWidthOfLiveStreamForCss(isMobileEvaluated, isRestrictedToMaxWidth50Pct),
                width: props.canLimitWidth ? "90%" : "100%", margin: "auto"/*, display: statePlayerWasReady ? "block" : "none" */
                , position: 'relative'
            }}
        >

            {
                props.popupWindowData &&
                <div className="top-controls">
                    <span className="fa fa-external-link-alt"
                        onClick={() => {
                            (window as any).easit = (window as any).easit || {};
                            (window as any).easit.sportsBettingLivestreamData = {
                                token: props.popupWindowData.token,
                                userId: props.popupWindowData.userId,
                                streamId: props.popupWindowData.streamId,
                                eventName: props.popupWindowData.eventName,
                                eventDiscipline: props.popupWindowData.eventDiscipline,
                                eventCategoryPath: props.popupWindowData.eventCategoryPath,
                            };
                            let win = window.open("/livestream/" + props.popupWindowData.eventId, "sb_livestream", "width=" + (getMaxWidthOfLiveStreamOnDesktopValue() + 30) + ",height=" + (getMaxWidthOfLiveStreamOnDesktopValue() * 0.5625 /* is it always same ratio? */ + 90) + ",toolbar=0,menubar=0,status=0,location=0");
                            //closeMonitor.setLastOpenWindowInstance(win);
                            win.focus();
                            if (player.current) {
                                player.current.stopVideo();
                            }
                            return false;
                        }}>
                    </span>
                    <span className="fa fa-times ml-2" onClick={props.closeVideo}></span>
                </div>
            }

            <video>
                {props.linkHls && <source src={props.linkHls}></source>}
                {props.linkDash && <source src={props.linkDash}></source>}
            </video>
        </div >

    </>
}